import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { API, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out

  useEffect(() => {
    API.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await API.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await API.post("/auth/register", payload);
    if (data.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await API.post("/auth/logout").catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  const refreshUser = useCallback(async () => {
    const { data } = await API.get("/auth/me");
    setUser(data);
    return data;
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function homeFor(user) {
  if (!user) return "/auth";
  if (user.role === "admin") return "/admin";
  if (user.role === "promoter") return "/promoter";
  if (user.role === "venue") return "/venue-dash";
  return "/app";
}
